import React from "react";
import { plans } from "../../servicesData";

export default function PricingPlans() {
  return (
    <section className="pricing-section">
      <div className="container text-center">
        <div className="mu-eyebrow on-purple">Simple Pricing</div>
        <h2 className="section-title" style={{ color: "#fff" }}>Pick Your Plan</h2>

        <div className="row g-4 justify-content-center mt-4">
          {plans.map((plan) => (
            <div className="col-md-4" key={plan.name}>
              <div className={`plan-card ${plan.popular ? "plan-card-popular" : ""}`}>
                {plan.popular && <span className="plan-badge">Most Popular</span>}
                <div className="plan-name">{plan.name}</div>
                <div className="plan-price">
                  {plan.price}
                  <span>/{plan.period}</span>
                </div>
                <ul className="plan-features">
                  {plan.features.map((f, i) => (
                    <li key={i}>
                      <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.485 1.431a1.5 1.5 0 0 1 .084 2.118l-7.5 8.25a1.5 1.5 0 0 1-2.15.048l-3.75-3.75a1.5 1.5 0 1 1 2.122-2.122l2.628 2.628 6.447-7.088a1.5 1.5 0 0 1 2.119-.084Z" />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <button className={plan.popular ? "btn-mu-dark plan-btn" : "btn-mu-dark plan-btn plan-btn-alt"}>
                  Get Started
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
